export const MODULE = "create-invoice-email-card";

export const DEFAULT_EMAIL_MESSAGE =
  "A PDF copy of the order has been attached to this email.\n\nTo view your order online, please click the 'View my order' button.";
